export enum NotificationType {
    AwaitingAcceptanceOrder = 'Orders.OrderAwaitingAcceptance',
    AcceptedOrder = 'Orders.OrderAccepted',
    PostponedOrder = 'Orders.OrderPostponed',
}
